import { Image } from '@components';
import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { breakpoints } from '@themes/theme.helpers';
import { useContext } from 'react';
import { ProductDetailsContext } from './ProductDetailsContext';
type ProductLogoProps = {
  //define your props here
};
const ProductLogoWrapper = styled(Box)`
  display: flex;
  justify-content: flex-end;
  img {
    width: 100%;
    max-width: 180px;
    max-height: 70px;
    margin-bottom: 32px;
  }

  ${breakpoints.down('md')} {
    display: none;
  }
`;

export const ProductLogo: React.FC<ProductLogoProps> = () => {
  const { product = {} } = useContext(ProductDetailsContext);
  const { brand = {} } = product;
  const imageUrl = brand?.expanded?.imageUrl;

  return (
    <ProductLogoWrapper>
      <Image image={imageUrl} resizerParams={{ width: 100, format: 'webp' }} />
    </ProductLogoWrapper>
  );
};
